import React from "react"
import PropTypes from "prop-types"
import { Button } from "antd"
import { useTranslation } from "react-i18next"
import styles from "./UploadFile/index.module.css"

/**
 * Import Error Message Component
 * Displays error message with a "See more info" link for import failures
 * Follows Single Responsibility Principle - only handles error message display
 *
 * @param {Object} props - Component props
 * @param {string} props.errorMessage - The error message to display
 * @param {Function} props.onViewDetails - Callback when "See more info" is clicked
 */
const ImportErrorMessage = ({ errorMessage, onViewDetails }) => {
  const { t } = useTranslation()

  return (
    <div>
      {errorMessage}
      <Button type="link" onClick={onViewDetails} className={styles.viewDetailsButton}>
        {t("clients.import_report.see_more_info")}
      </Button>
    </div>
  )
}

ImportErrorMessage.propTypes = {
  errorMessage: PropTypes.string.isRequired,
  onViewDetails: PropTypes.func.isRequired
}

export default ImportErrorMessage
